import { Navigate, type RouteObject } from 'react-router';
import { LandingLayout } from '@/layouts/landing-layout';
import { HomePage } from '@/pages/home-page';

export const routes: RouteObject[] = [
  {
    element: <LandingLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
];
